if (process.env.FRONT_ENV !== 'prod') {
  window.isMapDisabled = false;
  window.isDDErrorsHidden = false;

  window.disableMap = function () {
    window.isMapDisabled = true;
  };

  window.hideDDErrors = function () {
    window.isDDErrorsHidden = true;
  };
}
